'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeBoxIcon = function TraceTypeBoxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M23 23v16m4 0h-8m8-16h-8m-8-12v24m4 0H7m8-24H7m28-2v24m4 0h-8m8-24h-8', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M8 18h6v10H8z' }),
        _react2.default.createElement('path', { d: 'M13 19v8H9v-8h4m2-2H7v12h8V17z', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M20 29h6v4h-6z' }),
        _react2.default.createElement('path', { d: 'M25 30v2h-4v-2h4m2-2h-8v6h8v-6z', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M32 14h6v14h-6z' }),
        _react2.default.createElement('path', { d: 'M37 15v12h-4V15h4m2-2h-8v16h8V13z', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M38 21h-6m-18 1H8', strokeMiterlimit: '10', strokeWidth: '2' })
    );
};

exports.default = TraceTypeBoxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeBoxIcon.js
// module id = 705
// module chunks = 0